<script setup lang="ts">
defineProps<{
  label: string;
  items: Array<{ label: string; value: string }>;
}>();
</script>

<template>
  <div v-if="items.length">
    <p class="mb-1.5 text-[0.65rem] uppercase tracking-wide text-neutral-500">{{ label }}</p>
    <div class="flex flex-wrap gap-1.5">
      <span
        v-for="item in items"
        :key="item.label"
        class="rounded bg-white/5 px-2 py-1 text-xs text-neutral-300"
      >
        {{ item.label }} <span class="font-medium text-white">{{ item.value }}</span>
      </span>
    </div>
  </div>
</template>
